import React from "react";
import { useField } from "react-form";

const Text = (props) => {
  const {
    meta: { error, isTouched, isValidating },
    getInputProps
  } = useField(props.field, {})

  const inputProps = getInputProps()
  inputProps.value = inputProps.value || '' // bugfix, value can't be undefined

  return (
    <>
      <input {...inputProps} className={props.className} />
    </>
  );
}

export default Text